// constants.js - MODIFIÉ pour assurer la globalité

// Attache directement à l'objet window
window.ON_CHANGE_DEBOUNCE_TIMER = 300;

window.PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// Log pour confirmer que constants.js s'est exécuté et a défini PUB_SUB_EVENTS
console.log('[constants.js] PUB_SUB_EVENTS defined on window:', window.PUB_SUB_EVENTS);